<template>
	<section class="relativeclass">
		<label>Tags<span class="asterik">*</span></label>
		<div class="customised-form-tags">
			<b-form-tags
				:class="{ error: validation }"
				ref="tags"
				no-outer-focus
				remove-on-delete
				invalid-tag-text="Duplicate tag(s)"
				separator=",;"
				placeholder="Enter"
				v-model="tags"
			></b-form-tags>
			<div
				style="position: absolute;top: 37px;
    right: 6px;"
				v-if="validation"
				v-b-popover.hover.top.v-danger="{ content: 'Required' }"
				variant="primary"
			>
				<img src="../../assets/deletepopupicon.svg" alt="" />
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "FormTags",
	props: {
		validation: {
			type: Boolean,
			default: false,
		},
		value: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			tags: this.value,
		};
	},
	watch: {
		value(newVal) {
			this.tags = newVal;
		},
		tags(newVal) {
			this.$emit("input", newVal);
		},
	},
};
</script>
<style>
.customised-form-tags .b-form-tags-list .btn {
	display: block !important;
	height: 20px;
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px !important;
	color: #20639b;
	border: 1px solid #20639b;
	border-radius: 13px;
	padding: 0px 10px;
	cursor: pointer;
	margin: 2px;
}

.customised-form-tags .b-form-tags-list .btn-outline-secondary:hover {
	background-color: unset !important;
	box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.21);
	color: #20639b;
}

.customised-form-tags
	.b-form-tags-list
	.btn-outline-secondary:not(:disabled):not(.disabled):active {
	color: #20639b;
	box-shadow: none !important;
}

.customised-form-tags .error.form-control {
	box-sizing: border-box;
	padding: 0px 21px 0px 14px;
}

.customised-form-tags .form-control {
	box-sizing: border-box;
	padding: 0px 14px;
	background: #ffffff;
	/* border: 1px solid #d0d5dd !important; */
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 17px;
	color: #333333;
	height: 40px !important;
}

.customised-form-tags .b-form-tags .form-control {
	height: 36px !important;
}

.customised-form-tags div ul {
	flex-wrap: nowrap !important;
	overflow-y: hidden;
	overflow-x: auto;
	height: 100%;
	margin-top: unset !important;
}

.customised-form-tags .badge-secondary {
	background-color: #f1f7ff;
	border-radius: 15px;
	padding: 4px 10px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #20639b;
}

.customised-form-tags .b-form-tag > button.b-form-tag-remove {
	color: inherit;
	font-size: 101%;
	line-height: 1;
	padding: 0px 2.5px;
	float: none;
	top: 0;
	margin-left: 0.25rem;
	color: #20639b;
}

.customised-form-tags .b-form-tags .b-form-tags-list input::placeholder {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
	opacity: 0.4;
}

.customised-form-tags .text-muted {
	position: absolute;
	left: 0;
	color: red !important;
	bottom: -21px;
	font-size: 11px !important;
	font-weight: 500 !important;
	width: 100%;
	word-break: break-all;
}

.customised-form-tags .invalid-feedback {
	position: absolute !important;
	left: 0 !important;
	color: red !important;
	bottom: -21px !important;
	font-size: 11px !important;
	font-weight: 500 !important;
}

.customised-form-tags .b-form-tag > button.b-form-tag-remove {
	border: 1px solid #20639b;
	border-radius: 13px;
	height: 13px;
	font-size: 101%;
	line-height: 1;
	padding: 0px 2.5px;
	float: none;
	opacity: 1;
	margin-left: 10px;
	color: #20639b;
}
</style>
